import React from 'react';
import { Button, TextField, Typography, CircularProgress } from '@mui/material';
import type { AuthView } from './types';

interface ForgotPasswordFormProps {
  email: string;
  setEmail: (v: string) => void;
  loading: boolean;
  handleForgotPasswordSubmit: (e: React.SyntheticEvent) => void;
  handleViewChange: (view: AuthView) => void;
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  email,
  setEmail,
  loading,
  handleForgotPasswordSubmit,
  handleViewChange,
}) => (
  <form onSubmit={handleForgotPasswordSubmit}>
    <Typography variant="body2" sx={{ color: '#555', mb: 2 }}>
      Enter the email address tied to your account. We will transmit a temporary verification code to reset your access string.
    </Typography>
    <TextField
      fullWidth
      label="Email Address"
      variant="outlined"
      margin="normal"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      disabled={loading}
      autoComplete="email"
    />
    <Button
      fullWidth
      type="submit"
      variant="contained"
      size="large"
      disabled={loading}
      sx={{ mt: 3, height: 48, backgroundColor: '#FFBC0D', color: '#000', fontWeight: 700, '&:hover': { backgroundColor: '#e5a90c' } }}
    >
      {loading ? <CircularProgress size={24} /> : 'Send Reset Code'}
    </Button>
    <Button
      fullWidth
      type="button"
      variant="text"
      onClick={() => handleViewChange('login')}
      disabled={loading}
      sx={{ mt: 1, color: '#555' }}
    >
      Back to Login
    </Button>
  </form>
);
